export default __webpack_public_path__ + "static/media/img.69c1a894.svg";